export const T = {
  en_GB: { noImage: "No image configured" },
  nb_NO: { noImage: "Det er ikke konfigurert noe bilde" },
} as const;
